import { API } from 'aws-amplify';

const fetchAvailableNumbers = async areaCode => {
  try {
    const data = await API.get('agentbuzz', `availableNumbers/${areaCode}`);
    return data.map(availableNumber => {
      return availableNumber.number;
    });
  } catch (e) {
    return e.message;
  }
};

export default fetchAvailableNumbers;



// WEBPACK FOOTER //
// ./src/services/phoneNumber/fetchAvailableNumbers.js